import { isEmpty } from 'lodash';
import { getImpersonation } from '../../redux/actionCreators/async/impersonation';
import { updateImpersonateUser } from '../../redux/actionCreators/sync/impersonation';

export default function OnEnterLoadImpersonation(store) {
  return (nextState, replace, done) => {
    const state = store.getState();
    if ((!!~state.user.roles.indexOf('Admin') || !!~state.user.roles.indexOf('Qualifying Specialist') || !!~state.user.roles.indexOf('Support Assistant')
      || !!~state.user.roles.indexOf('Reference Specialist') || !!~state.user.roles.indexOf('Placement Specialist'))
      && isEmpty(state.user.impersonateUser)) {
      store.dispatch(getImpersonation((err, impersonateUser) => {
        if (err || !impersonateUser) {
          return done();
        }
        store.dispatch(updateImpersonateUser({impersonateUser}));
        return done();
      }));
    }
    else {
      done();
    }
  };
}



// WEBPACK FOOTER //
// ./shared/react/OnEnterHooks/loadImpersonation.js